var exports = {
  "container": "x0a7806d5--3c25b0--container",
  "container--size-m": "x0a7806d5--3c25b0--container--size-m",
  "container--size-s": "x0a7806d5--3c25b0--container--size-s",
  "container--active": "x0a7806d5--3c25b0--container--active",
};

module.exports = exports;
